export const tabs = {
  general: 'Ogólne',
  options: 'Opcje',
  actions: 'Akcje',
  properties: 'Właściwości',
} as const
